import React, { Suspense } from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { func, string } from 'prop-types';

const Overlay = React.lazy(() => import(/* webpackChunkName: "overlay" */ '@thd-olt-component-react/core-ui')
  .then((module) => ({ default: module.Overlay })));

const StoreLayout = React.lazy(() => import(/* webpackChunkName: "sl" */ '@thd-olt-component-react/store-layout')
  .then((module) => ({ default: module.StoreLayout })));

const Layout = ({ storeId, storeName, toggleOverlay }) => {
  return (
    <Suspense fallback={<div />}>
      <Overlay onClose={() => toggleOverlay(false)} open closeButton>
        <StoreLayout storeId={storeId} storeName={storeName} />
      </Overlay>
    </Suspense>
  );
};

Layout.propTypes = {
  storeId: string.isRequired,
  storeName: string.isRequired,
  toggleOverlay: func.isRequired
};

Layout.displayName = 'Layout';

Layout.dataModel = extend(StoreLayout);

export { Layout };
